<template>
  <div class="dtlplafons">
    <a-collapse activeKey="1" :class="getScreen?'margin-top':''">
      <a-collapse-panel key="1">
        <span slot="header">Detil Allocation Budget</span>
        <a-card :loading="loading" :style="getScreen? 'padding:15px':''">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Directorate {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? datasource.allocation.directorat : "-" }}</div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Total Plafon {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? formatCurrency('IDR', datasource.allocation.plafon_value) : "-" }}</div>
              </div>
            </a-col>
          </a-row>
          <!-- <a-row :gutter="8" v-if="versionType=='Operational'">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Total Pipeline {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? formatCurrency('IDR', datasource.allocation.pipeline_plafon) : "-" }}</div>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="8" v-if="versionType=='Operational'">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Total Directorate Cost {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? formatCurrency('IDR', datasource.allocation.biaya_direktorat_plafon) : "-" }}</div>
              </div>
            </a-col>
          </a-row> -->
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Total Allocated {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? formatCurrency('IDR',datasource.allocation.allocated_value) : "-" }}</div>
              </div>
            </a-col>
          </a-row>
          <!-- <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
              <b>Unallocated Plafon {{!getScreen?' ':" :"}}</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? 
                  formatCurrency('IDR',Number(datasource.allocation.plafon_value)-Number(datasource.allocation.allocated_value)) : "-" }}
                </div>
              </div>
            </a-col>
          </a-row> -->
          <a-row :gutter="8"  v-if="type=='monthly'">
            
            <a-col :xs="{ span: 24 }" :lg="{ span: 9 }" class="fontGreen">
              <b>Available Plafon {{!getScreen?' ':" :"}}</b>
            </a-col>
            <b>
            <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" class="fontGreen">
              <div class="m-display-flex space-between">
                <div>{{getScreen?' ':":"}}</div>
                <div>{{ datasource.allocation ? 
                  formatCurrency('IDR', availablePlafon) : "-" }}
                </div>
              </div>
            </a-col>
            </b>
          </a-row>
          <!-- <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>Total Realization</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
              : {{ datasource.allocation ? formatCurrency('IDR',datasource.allocation.realization_value) : "-" }}
            </a-col>
          </a-row> -->
        </a-card>
        <a-card class="margin-top" v-if="type=='annual'" :loading="loading">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <b>BUDGET TYPE :</b>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            </a-col>
          </a-row>
          <a-tree :load-data="onLoadData" :tree-data="datasource.budget" class="treedt">
            <template slot="title" slot-scope="item">
              <a-row :gutter="1" v-if="!getScreen">
                <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">{{ item.dataRef.title }}</a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="item.dataRef.value"
                  />
                </a-col>
              </a-row>
              <span v-else>{{ item.dataRef.title }} - ({{ formatCurrency('IDR',item.dataRef.value) }})</span>
            </template>
          </a-tree>
        </a-card>
        <div v-if="type=='monthly'" class="monthlytbl">
          <div class="margin-top">
            <a-tooltip placement="bottomLeft">
              <b>Set PP/SPPD Priority List &nbsp;<sup><a-icon type="info-circle"/></sup> :</b>
              <template slot="title">
                <span>* White Background : New Data / WhiteList.</span><br/>
                <span>* Yellow Background : The Data Was Allocated.</span><br/>
                <span>* Green Background : The Data Has Been Realized.</span><br/>
              </template>
            </a-tooltip>
          </div>
          <a-config-provider :locale="getLocalConfigProvider()">
            <a-table 
              id="sourceData"
              :rowKey="(record)=>{return record.id_trans+':'+record.jenis+':'+record.cek}"
              :columns="columnsCondition" 
              :data-source="datasource.allocated"
              :loading="loading || loadtable"
              :scroll="{ y: 825 }"
              :pagination="type=='monthly'?false:pagination"
              :class="getScreen ? 'dndTable autoHeight' : 'dndTable'"
              :rowClassName="(record) => {return Number(record.cek)==1? (Number(record.realisasi)>0?'hasbeenPriorityPlafon' : 'availabelPriorityPlafon') : '' }"
              size="small"
              bordered
              :customRow="(record)=>{
                  return {
                    on: {
                      click: (event) => {toManifest(record)}, }}}"
              >
              <template slot="btn" slot-scope="item">
                <a-button :id="'swap_'+item.id_trans" icon="swap" :type="'secondary'" style="transform: rotate(90deg);"/>
              </template>
              <span slot="customTitle">No</span>
              <template slot="checbox" slot-scope="item">
                <a-checkbox 
                  :disabled="status=='On Process' || (Number(item.realisasi)>0 && item.cek!='0') || Number(item.saldo)<0" 
                  :checked="item.cek=='1'" 
                  @click="(e)=>{e.stopPropagation()}"
                  @change="(e) => {handleCheckbox(e,item)}"/>
              </template>
              <template slot="no" slot-scope="text, item, index">
                {{ pagination.pageSize > index+1 ? index+1 : ((pagination.current-1)*pagination.pageSize)+index+1 }}
              </template>
              <template slot="pp" slot-scope="item">
                {{ item.no_trans }}
              </template>
              <template slot="desc" slot-scope="item">
                {{ item.deskripsi }}
              </template>
              <template slot="value" slot-scope="item">
                {{ formatCurrency('IDR',item.value_kurs) }}
              </template>
            </a-table>
          </a-config-provider>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import CurrencyFormat from "@/mixins/CurrencyFormat"
import GlobalMethod from "@/mixins/GlobalMethod.js"
import Sortable, { AutoScroll } from 'sortablejs/modular/sortable.core.esm.js'
import _ from "lodash";
import HandleRoute from "@/mixins/HandleRoute";

export default {
  name: "Details",
  props: {
    datasource: {},
    loading: Boolean,
    type: String,
    versionType: String,
    status: String,
  },
  mixins: [CurrencyFormat, GlobalMethod, HandleRoute],
  data() {
    return {
      columns:[
        {
          slots: { title: 'customTitle' },
          key: "no",
          width: "40px",
          align: "right",
          scopedSlots: { customRender: 'no' },
        },{
          title: 'No PP',
          key: "pp",
          width: this.getScreen ? "" : "150px",
          scopedSlots: { customRender: 'pp' },
        },{
          title: 'Description',
          key: "desc",
          width: this.getScreen ? "" : "250px",
          scopedSlots: { customRender: 'desc' },
        },{
          title: 'Value',
          key: "value",
          width: "125px",
          align: "right",
          scopedSlots: { customRender: 'value' },
        }
      ],
      pagination: {
        onChange: (page) => {
          this.pagination.current = page;
        },
        current: 1,
        pageSize: 10,
        size: "small",
      },
      tempNewData: [],
      sourceData:[],
      approveToMove: false,
      isCursorAroundTheArea: false,
      loadtable: false,
      dtlRowOriginalBeforeDrag: [],
      startedBtnKey: false
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
    ]),
    availablePlafon(){
      return Number(this.datasource.allocation.plafon_value) -
        _.sumBy(this.datasource.allocated, function (val) {
        return (Number(val.saldo)>=0 ? Number(val.value_kurs) : 0)
      });
    },
    columnsCondition(){
      let a = [...this.columns]
      if(this.datasource.allowDragDrop){
        a.splice(0, 0, {
          title: '#',
          key: "btn",
          width: "50px",
          scopedSlots: { customRender: 'btn' },
        });
        a.splice(0, 0, {
          title: '#',
          key: "checbox",
          width: "50px",
          align: "center",
          class:"tdCheckBox",
          scopedSlots: { customRender: 'checbox' },
        })
      }
      return a
    }
  },
  methods:{
    async onLoadData(treeNode){
      return await new Promise(async (resolve) => {
        if (treeNode.dataRef.children) {
          resolve();
          return;
        }

        await this.asyncAxiosGet("plafon/budget_detil",
          this.getAuth, {
            id:this.datasource.allocation.id,id_dtl: treeNode.dataRef.id_dtl, kode_jenis: treeNode.dataRef.key
          }
        ).then((res) => {
          this.tempNewData = []
          res.active_code.forEach((element, index) => {
            this.tempNewData.push({
              key: element.kode_jenis + index,
              title: element.cost_center_kode,
              isLeaf: true,
              isChild: true,
              value: element.nilai,
              scopedSlots: { title: 'title'}
            })
          });
          treeNode.dataRef.children = this.tempNewData
          let a = this.datasource.budget
          a = [...this.datasource.budget];
          Event.$emit("annualPlafonUpdateData", a);
          resolve();
        })
      });
    },
    initDrugable() {
      
    let tableSource = document.getElementById('sourceData');
    let tbodyTableSource = tableSource.querySelector("tbody");

    const _self = this; // this way we avoid data binding

    Sortable.mount(new AutoScroll());

    Sortable.create(tbodyTableSource, {sort:true,group: {name:'sourceData',pull:'clone',put:['sourceData']},

          scroll: true, // or HTMLElement
          // scrollFn: function(offsetX, offsetY, originalEvent, touchEvt, hoverTargetEl) {
          //  }, // if you have custom scrollbar scrollFn may be used for autoscrolling
          scrollSensitivity: 50, // px, how near the mouse must be to an edge to start scrolling.
          scrollSpeed: 10, // px
          bubbleScroll: true, // apply autoscroll to all parent elements, allowing for easier movement
          delay: 500,
          forceFallback: true,
          animation: 100,
          invertSwap: false,
          setData(evt){
            // console.log("setData",evt);
          },
          onChoose(evt){
            //flag button as active drag
            const isd = evt.item.dataset.rowKey.split(":")
            this.startedBtnKey = isd[0]
            document.getElementById("swap_"+isd[0]).classList.add('ant-btn-primary');
            document.getElementById("swap_"+isd[0]).classList.remove('ant-btn-secondary');
          },
          onUnchoose(evt){
            // console.log("onChoose",evt);
          },
          onAdd(evt){
            // console.log("onAdd",evt);
          //   return false
          },
          onUpdate(evt){
            // console.log("onUpdate",evt)
          //   return false
          },
          onStart(evt){
            // console.log("onStart",evt)
            _self.dtlRowOriginalBeforeDrag = evt.item
          },
          onMove(evt){
            // console.log("onMove",evt)
            if(!_self.datasource.allowDragDrop || 
              evt.related.dataset.rowKey.split(":")[2]=='1' || 
              evt.dragged.dataset.rowKey.split(":")[2]=='1' || 
              // _self.status=='On Process' || 
              _self.status=='non active'){
              _self.approveToMove = false
              return false;
            }else{
              _self.approveToMove = true
            }
          },
          onSort(evt){  
            // console.log("onSort",evt)
            evt.preventDefault();
            _self.checkCursorAroundTheArea(document.getElementsByClassName('dndTable')[0].getBoundingClientRect(),evt)
            if(_self.approveToMove && _self.isCursorAroundTheArea){
              let datalist = []
              let key = []
              for (let i = 0; i < tbodyTableSource.children.length; ++i) {
                key = tbodyTableSource.children[i].dataset.rowKey.split(":")
                datalist.push({
                  seq_priority: i+1,
                  id_trans: key[0],
                  jenis_transaksi: key[1],
                })  
              }
              _self.loadtable = true
              _self.asyncAxiosPost("plafon/slide_priority", "application/json", _self.getAuth, {
                id: _self.datasource.allocation.id,
                id_dtl: _self.datasource.allocation.id_dtl,
                data: datalist
              })
              .then((res) => {
                Event.$emit("setShortingPriorityPlafon", res);

                //flag button as active drag
                const isd = evt.item.dataset.rowKey.split(":")
                this.startedBtnKey = isd[0]
                document.getElementById("swap_"+isd[0]).classList.add('ant-btn-secondary');
                document.getElementById("swap_"+isd[0]).classList.remove('ant-btn-primary');

                _self.loadtable = false
                return false
              })
              .catch(() => {
                _self.loadtable = false
                return false
              });
            }else{
              //flag button as active drag
              const isd = evt.item.dataset.rowKey.split(":")
              this.startedBtnKey = isd[0]
              document.getElementById("swap_"+isd[0]).classList.add('ant-btn-secondary');
              document.getElementById("swap_"+isd[0]).classList.remove('ant-btn-primary');
            }
          },
          onChange(evt){  
            // console.log("onChange",evt)
          },
          onEnd(evt){
            if(!_self.isCursorAroundTheArea) {
             evt.item.remove()
             evt.target.children[evt.oldIndex-1].after(_self.dtlRowOriginalBeforeDrag)
            }

            //flag button as active drag
            const isd = evt.item.dataset.rowKey.split(":")
            this.startedBtnKey = isd[0]
            document.getElementById("swap_"+isd[0]).classList.add('ant-btn-secondary');
            document.getElementById("swap_"+isd[0]).classList.remove('ant-btn-primary');
          }
      });
    },
    checkCursorAroundTheArea(item,evt){
      let BCR = item
      let cursorDragXPoint = evt.originalEvent.x
      let cursorDragYPoint = evt.originalEvent.y
      if(!(cursorDragXPoint>=BCR.left && cursorDragXPoint<=BCR.right &&
        cursorDragYPoint>=BCR.top && cursorDragYPoint<=BCR.bottom)
      ){
        this.isCursorAroundTheArea = false
      }else{
        this.isCursorAroundTheArea = true
      }
    },
    approveDrugPriorityplafon(item){
      // console.log("approveDrugPriorityplafon", item)
      item.from.remove();
      item.to.remove();
    },
    cancelDrugPriorityplafon(item){
      // console.log("cancelDrugPriorityplafon", item)
      this.displayMessageValue("basic-warning", "Failed set priority cause Max Limit plafon!");
      item.from.remove();
      // item.to.remove();
    },
    handleCheckbox(e,item){
      if(Number(item.value_kurs)>item.post_value){
        this.displayMessageValue("basic-warning", "Failed, Value ("+
          this.formatCurrency('IDR', Number(item.value_kurs))
        +") > Post Value ("+
          this.formatCurrency('IDR', item.post_value)
        +")!");
        return
      }
      const that = this;
      this.$confirm({
        title: "Are you sure to "+(e.target.checked?'Set Priority':'UnSet Priority')+" Data?",
        content: null,
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loadtable = true
          that.asyncAxiosPost("plafon/check_priority", "application/json", that.getAuth, {
            id_dtl: that.datasource.allocation.id_dtl,
            id: that.datasource.allocation.id,
            status: e.target.checked ? 1 : 0,
            id_trans: item.id_trans,
            jenis_transaksi: item.jenis,
            seq_priority: item.shorting,
            value_kurs: item.value_kurs
          })
          .then((res) => {
            Event.$emit("setShortingPriorityPlafon", res);
            that.loadtable = false
            // console.log(res)
          })
          .catch((err) => {
            console.log(err)
            that.loadtable = false
          });
        },
        onCancel() {
          e.stopPropagation()
        },
      });
    },
    toManifest(val){
      if(this.datasource.allowDragDrop){
        val.rest_api = (val.jenis=='pd' ? 'sppds' : val.jenis)
        val.id_manifest = val.id_trans
        val.user_pembuat = val.pembuat
        this.handleView(val, true)
      }
    },
    setFalseLoadingData(){
      this.loadtable = false
    }
  },
  mounted(){
    Event.$on("cancelDrugPriorityplafon", this.cancelDrugPriorityplafon);
    Event.$on("approveDrugPriorityplafon", this.approveDrugPriorityplafon);
    Event.$on("loadingTblOriDtlData", this.setFalseLoadingData);
    if(this.type=='monthly')
    this.initDrugable()

    
  },
  beforeDestroy() {
    Event.$off("cancelDrugPriorityplafon", this.cancelDrugPriorityplafon);
    Event.$off("approveDrugPriorityplafon", this.approveDrugPriorityplafon);
    Event.$off("loadingTblOriDtlData", this.setFalseLoadingData);
  }
}
</script>
<style lang="less">
.treedt{
  .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-normal{
    width: 100%;
    padding: 0 24px 0 0;
  }
  .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-close{
    width: 100%;
    padding: 0 24px 0 0;
  }
  .ant-tree-node-content-wrapper.ant-tree-node-content-wrapper-open{
    width: 100%;
    padding: 0 24px 0 0;
  }

  .ant-tree-node-content-wrapper{
    display: inline-table;
    word-break: break-all;
    text-wrap: auto;
  }
}
.ant-tree li .ant-tree-node-content-wrapper{
  display: inline-table;
    word-break: break-word;
    text-wrap: auto;
}

.tdCheckBox{
  padding: 4px !important;
}
.fontGreen{
  color: @color-secondary;
}
.availabelPriorityPlafon  {
    // background-color: fade(@color-secondary, 50%);
    // font-weight: 500;
    // color: darken(@color-secondary, 5%);
    // background-color: fade(@color-secondary, 50%);
    background-color: fade(#fbff00, 15%);
  }
.hasbeenPriorityPlafon{
  // font-weight: 500;
  // color: fade(#d9d9d9, 100%);
  background-color: fade(@color-secondary, 30%);
}

.dndTable{
  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
  .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
  .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td, 
  .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: none;
    cursor: pointer;
  }
}

.autoHeight{
  .ant-table-body{
    height: 70vh!important;
  }
}
/* width */
.dndTable{
  ::-webkit-scrollbar {
    width: 15px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
}
</style>